import Textarea, { TextareaProps } from "../Base/Textarea";
import HelperText from "../HelperText";
import Label from "../Label";

export interface FieldProps extends Omit<TextareaProps, "error"> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
}

const TextAreaField: React.FunctionComponent<FieldProps> = ({
  label,
  error,
  errorMessage = null,
  helperText = null,
  ...props
}) => {
  return (
    <Label content={label} block={props.block}>
      <Textarea {...props} error={Boolean(errorMessage || error)} />
      <HelperText
        content={errorMessage || helperText || ""}
        error={Boolean(errorMessage || error)}
      />
    </Label>
  );
};

export default TextAreaField;
